import { FlexBox, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { motion, useScroll, useTransform } from 'framer-motion'
import { MLPHeroImage } from './MLPHeroImage'
import { MLPDownloadAppCTA } from '../MLPDownloadAppCTA'

interface TextProps {
  className?: string
  text: string
}

interface Props {
  header: TextProps
  subheader: TextProps
  description: TextProps
}

export const MLPHero = ({ header, subheader, description }: Props) => {
  const { colors, mediaQueries } = useTheme()
  const { scrollYProgress } = useScroll({
    offset: ['start start', '25% start'],
  })
  const height = useTransform(scrollYProgress, [0, 1], ['100%', '0%'])

  return (
    <div
      className={css`
        padding-bottom: 44px;
        position: relative;
      `}
    >
      <span
        className={css`
          display: block;
          width: 100%;
          height: 80vw;
          position: absolute;
          inset: 0 auto auto 0;
          ${mediaQueries.mobileL} {
            height: max(40.365vw, 420px);
          }
          ${mediaQueries.desktop} {
            height: 465px;
          }
          ${mediaQueries.desktopL} {
            height: 490px;
          }
        `}
      >
        <motion.span
          style={{ height }}
          className={css`
            width: 100%;
            position: absolute;
            inset: 0 auto auto 0;
            background-color: ${colors.uiPearlExtraLight};
          `}
        />
      </span>
      <FlexBox
        className={css`
          position: relative;
          padding: 48px 0 0;
        `}
        flexDirection="column"
        alignItems="center"
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ ease: 'easeOut', duration: 1 }}
        >
          <FlexBox flexDirection="column" alignItems="center">
            <Text
              className={subheader.className || ''}
              type="script"
              align="center"
              color={colors.uiGreen}
              custom={{
                fontSize: 'min(10.679vw, 64px)',
                lineHeight: 'min(10.679vw, 64px)',
              }}
            >
              {subheader.text}
            </Text>
            <Text
              className={header.className || ''}
              type="header"
              align="center"
              color={colors.uiGraphite}
              custom={{
                fontSize: 'min(14.599vw, 80px)',
                lineHeight: 'min(14.599vw, 80px)',
              }}
            >
              {header.text}
            </Text>
          </FlexBox>
        </motion.div>
        <MLPHeroImage />
        <FlexBox
          className={css`
            position: relative;
          `}
          flexDirection="column"
          alignItems="center"
        >
          <Text
            className={cx(
              css`
                margin-bottom: 20px;
                max-width: 300px;
                ${mediaQueries.mobileL} {
                  max-width: 390px;
                }
              `,
              description.className || ''
            )}
            type="body"
            sizing={{ base: 'M', mobileL: 'XL' }}
            align="center"
          >
            {description.text}
          </Text>
          <MLPDownloadAppCTA />
        </FlexBox>
      </FlexBox>
    </div>
  )
}
